import React from 'react';
import { Box, Typography, Tab, Avatar, FormHelperText } from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  Link as LinkIcon,
} from '@mui/icons-material';
import Card from '../UIKit/Card';
import Tabs from '../UIKit/Tabs';
import Button from '../UIKit/Button';
import TextField from '../UIKit/TextField';
import { useTranslation } from 'react-i18next';

const SeriesImageSelector = ({
  previewSeriesImage,
  setPreviewSeriesImage,
  seriesFormData,
  setSeriesFormData,
  formErrors,
  imageUploadTab,
  handleImageTabChange,
  fileInputRef,
  handleChooseFile,
  handleSeriesFormChange,
}) => {
  const { t } = useTranslation(['badges', 'common']);
  
  // Обработчик загрузки файла изображения для серии
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Проверка типа файла
    if (!file.type.startsWith('image/')) {
      // Тут можно добавить обработку ошибки, если нужно
      return;
    }

    // Проверка размера файла (не более 2MB)
    if (file.size > 2 * 1024 * 1024) {
      // Тут можно добавить обработку ошибки, если нужно
      return;
    }

    // Создаем предпросмотр изображения
    const reader = new FileReader();
    reader.onload = (e) => {
      const imageDataUrl = e.target.result;
      setPreviewSeriesImage(imageDataUrl);
    };
    reader.readAsDataURL(file);

    // Сохраняем файл для отправки
    setSeriesFormData({
      ...seriesFormData,
      imageFile: file,
    });
  };

  return (
    <Card sx={{ mb: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        {t('badges:seriesImageSelector.title')}
      </Typography>

      <Box
        sx={{
          bgcolor: 'background.default',
          borderRadius: { xs: '12px', sm: '16px' },
          p: '4px',
          width: '100%',
          overflow: 'hidden',
          mb: 2,
        }}
      >
        <Tabs
          value={imageUploadTab}
          onChange={handleImageTabChange}
          aria-label="image upload tabs"
        >
          <Tab
            icon={<CloudUploadIcon />}
            label={t('badges:seriesImageSelector.uploadTab')}
          />
          <Tab
            icon={<LinkIcon />}
            label={t('badges:seriesImageSelector.urlTab')}
          />
        </Tabs>
      </Box>

      {imageUploadTab === 0 ? (
        <Box>
          <Button
            variant="contained"
            component="span"
            startIcon={<CloudUploadIcon />}
            onClick={handleChooseFile}
            sx={{ mb: 2 }}
          >
            {t('common:actions.chooseFile')}
          </Button>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
          {formErrors.seriesImage && (
            <FormHelperText error>{formErrors.seriesImage}</FormHelperText>
          )}
        </Box>
      ) : (
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label={t('badges:seriesImageSelector.imageUrl')}
            value={seriesFormData.image || ''}
            onChange={(e) => handleSeriesFormChange('image', e.target.value)}
            InputProps={{
              startAdornment: (
                <LinkIcon sx={{ color: 'action.active', mr: 1 }} />
              ),
            }}
            error={!!formErrors.seriesImage}
            helperText={formErrors.seriesImage}
          />
        </Box>
      )}

      {(previewSeriesImage || seriesFormData.image) && (
        <Box
          sx={{
            textAlign: 'center',
            mt: 2,
          }}
        >
          <Typography variant="subtitle2" gutterBottom>
            {t('common:preview')}
          </Typography>
          <Avatar
            src={previewSeriesImage || seriesFormData.image}
            alt="Preview"
            sx={{
              width: 100,
              height: 100,
              mx: 'auto',
            }}
          />
        </Box>
      )}
    </Card>
  );
};

export default SeriesImageSelector;
